import { constants as config } from '@config';

const DesignFacade = require('./facade/design/design');
const EditorFacade = require('./facade/editor/editor');

module.exports = (function () {
  let elements = {};

  return {
    toggle,
    initialize,
    show: function (svgElement) { toggle(svgElement, true); },
    hide: function (svgElement) { toggle(svgElement, false); },
    hideAll: function () { _.each(elements, removeLoader); }
  };

  function initialize () {
    EditorFacade.on('page.saving', value => toggleLoading(true, value));
    EditorFacade.on('page.saved', value => toggleLoading(false, value));

    /**
     * Note: Regarding EDIT-2336
     * It was request to turn off top loader for image actions on the card
     */
    // DesignFacade.on('image.replace', value => toggleLoading(true, value));
    // DesignFacade.on('image.replace.skip', value => toggleLoading(false, value));
    // DesignFacade.on('image.create.optimize_resolution', value => toggleLoading(true, value));
    // DesignFacade.on('image.create.resize_external', value => toggleLoading(true, value));
    // DesignFacade.on('image.create.source.url', value => toggleLoading(false, value));
    // DesignFacade.on('image.create.optimus_resolution', value => toggleLoading(false, value));
    // DesignFacade.on('image.update.optimize_resolution', value => toggleLoading(true, value));
    // DesignFacade.on('image.update.resize_external', value => toggleLoading(true, value));
    // DesignFacade.on('image.update.source.url', value => toggleLoading(false, value));
    // DesignFacade.on('image.update.optimus_resolution', value => toggleLoading(false, value));

    // DesignFacade.on('background.remove_background.start', (...args) => toggleLoading(true, ...args, 60000));
    // DesignFacade.on('background.remove_background.success', value => toggleLoading(false, value));
    // DesignFacade.on('background.remove_background.skip', value => toggleLoading(false, value));
    // DesignFacade.on('background.remove_background.error', value => toggleLoading(false, value));
    // DesignFacade.on('image.remove_background.start', (...args) => toggleLoading(true, ...args, 60000));
    // DesignFacade.on('image.remove_background.success', value => toggleLoading(false, value));
    // DesignFacade.on('image.remove_background.skip', value => toggleLoading(false, value));
    // DesignFacade.on('image.remove_background.error', value => toggleLoading(false, value));

    // DesignFacade.on('background.update.updating_source', value => toggleLoading(true, value));
    // DesignFacade.on('background.update.source', value => toggleLoading(false, value));

    // DesignFacade.on('image.check_quality.start', value => toggleLoading(true, value));
    // DesignFacade.on('image.check_quality.end', value => toggleLoading(false, value));

    DesignFacade.on('flipping_image', value => toggleLoading(true, value));
    DesignFacade.on('flipped_image', value => toggleLoading(false, value));

    DesignFacade.on('icon.update.fetch_content', value => toggleLoading(true, value));
    DesignFacade.on('icon.update.content', value => toggleLoading(false, value));

    DesignFacade.on('logo.update.fetch_content', value => toggleLoading(true, value));
    DesignFacade.on('logo.update.content', value => toggleLoading(false, value));

    DesignFacade.on('icon.update.optimize_resolution', value => toggleLoading(true, value));
    DesignFacade.on('icon.update.resolution_optimized', value => toggleLoading(false, value));

    DesignFacade.on('logo.update.optimize_resolution', value => toggleLoading(true, value));
    DesignFacade.on('logo.update.resolution_optimized', value => toggleLoading(false, value));

    DesignFacade.on('video.create.optimize_resolution', value => toggleLoading(true, value));
    DesignFacade.on('video.create.resolution_optimized', value => toggleLoading(false, value));
    DesignFacade.on('video.update.optimize_resolution', value => toggleLoading(true, value));
    DesignFacade.on('video.update.resolution_optimized', value => toggleLoading(false, value));

    DesignFacade.on('svg_element_loader.show', value => toggleLoading(true, value));
    DesignFacade.on('svg_element_loader.hide', value => toggleLoading(false, value));

    DesignFacade.on('translations.parent_template_preview.loading', (...args) => toggleLoading(true, ...args, 60000));
    DesignFacade.on('translations.parent_template_preview.loaded', value => toggleLoading(false, value));
    DesignFacade.on('translations.parent_template_preview.error', value => toggleLoading(false, value));
    function toggleLoading (value, data, timeout) {
      const image = $('#' + data?.id)[0];
      image && toggle(image, value, timeout);

      const eventName = value ? 'show' : 'hide';
      DesignFacade.trigger(`svg_loader.${eventName}`, data, config.timeout.topLoader);
    }
  }

  function toggle (svgElement, isLoadingShowed, timeout) {
    // TODO: Remove jQuery
    // TODO: Use opacity to toggle loader
    const $svgElement = $(svgElement);
    let $localLoader = getLoader($svgElement);
    const $globalLoader = $('#global-loader');
    timeout = timeout || 15000;

    if (!isLoadingShowed) {
      removeLoader($svgElement);
      return;
    }

    if (!$localLoader) {
      if (!$globalLoader.length) {
        createNewLoader();
      } else {
        const elementId = $svgElement.attr('id');
        $globalLoader.addClass(`${elementId}-loader`);
      }
    }

    // Always stop loading after 15s
    setTimeout(() => {
      if (INKIVE.C.DEBUG) {
        console.warn('[Violation] \'SVGElementLoading\' handler took 15s. Automatically hiding it. svgElement:', svgElement);
      }
      toggle(svgElement, false);
    }, timeout);

    function createNewLoader () {
      const elementId = $svgElement.attr('id');

      $localLoader = $(`
              <div id="global-loader" class="linear-progress-root" role="progressbar">
                <div class="linear-progress-bar">
                  <div class="linear-progress-bar-inner">
                  </div>
                </div>
              </div>
            `)
        .addClass(`${elementId}-loader`)
        .prependTo('body');

      $svgElement.data('svg-loader', $localLoader);

      elements[elementId] = $svgElement;
    }
  }

  function removeLoader ($svgElement) {
    elements = _.omit(elements, $svgElement.attr('id'));

    const elementId = $svgElement.attr('id');
    $('#global-loader').removeClass(`${elementId}-loader`);
    $svgElement.removeData('svg-loader');

    if (Object.keys(elements).length === 0) {
      // All element loaders are finished so remove global loader
      $('#global-loader').remove();
    }
  }

  function getLoader ($svgElement) {
    if ($svgElement.data('svg-loader')) {
      return $svgElement.data('svg-loader');
    }

    const elementId = $svgElement.attr('id');
    const loader = $(`#global-loader.${elementId}-loader`);
    return loader.length ? loader : null;
  }
})();
